import React from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Button, Paper } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

const BillingCancel = () => {
    return (
        <Box
            sx={{
                minHeight: "80vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 2,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    maxWidth: 520,
                    width: "100%",
                    p: 4,
                    textAlign: "center",
                }}
            >
                <CancelIcon sx={{ fontSize: 64, color: "error.main", mb: 2 }} />

                <Typography variant="h5" fontWeight={700} gutterBottom>
                    Subscription Canceled
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                    Your subscription process was canceled and no payment was made.
                </Typography>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    If this was a mistake, you can try again at any time.
                    If you have questions, feel free to contact support.
                </Typography>

                <Button
                    component={Link}
                    to="/biz/pricing"
                    variant="contained"
                    size="large"
                    fullWidth
                    sx={{ mb: 1 }}
                >
                    Try Again
                </Button>

                <Button
                    component={Link}
                    to="/biz/dashboard"
                    variant="outlined"
                    fullWidth
                >
                    Back to Dashboard
                </Button>
            </Paper>
        </Box>
    );
};

export default BillingCancel;
